import React from 'react';
import SetPageNavAction from 'components/Portals/SetPageNavAction';
import { useTranslation } from 'services/localization';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Routes, useTypedLocation } from 'routing';
import ChangePlan from './ChangePlan';
import ConfirmPlan from './ConfirmPlan';

const Plans = () => {
	const { t } = useTranslation();

	const { state } = useTypedLocation();

	return (
		<>
			<SetPageNavAction
				priority={2}
				backAction={{ to: state?.from ?? null, title: t('common:actions.goBack') }}
				quickLinks={[]}
			/>
			<Switch>
				<Route exact path={Routes.PLANS} component={ChangePlan} />
				<Route exact path={Routes.PLANS_CONFIRM} component={ConfirmPlan} />
				<Redirect to={Routes.PLANS} />
			</Switch>
		</>
	);
};

export default Plans;
